/* eslint-disable */
import axios from 'axios'
import { qs } from 'url-parse';
// const PUBLISH_BASE_URL = 'https://free.fbee.site'
const PUBLISH_BASE_URL = 'https://free.growup.link'
//下载App链接
const App_Download_URL = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.engineering.markcamera'
// const App_Download_URL = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.camera.free'

const service = axios.create({})
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
service.defaults.baseURL = PUBLISH_BASE_URL

export function switchNetworkEnv (isTestMode) {
  if (isTestMode) {
    service.defaults.baseURL = PUBLISH_BASE_URL
  } else {
    service.defaults.baseURL = PUBLISH_BASE_URL
  }
}

export function inviteRegister(data) {
  return service.post('/freeapi/free/open/inviteRegister', qs.stringify(data))
}

export default {
  switchNetworkEnv,
  inviteRegister,
  App_Download_URL
}



// WEBPACK FOOTER //
// ./src/NetworkHelper.js